import { MessageCircle } from "lucide-react";
import { whatsappLink } from "@/lib/site";

export function WhatsAppFloat() {
  return (
    <a
      href={whatsappLink()}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Falar pelo WhatsApp"
      className="fixed bottom-6 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-elegant transition-spring hover:scale-110 hover:bg-[#20BA5A] animate-pulse-glow"
    >
      <MessageCircle className="h-7 w-7" fill="white" />
      <span className="sr-only">WhatsApp Podomasso</span>
    </a>
  );
}
